import {combineLatest,  BehaviorSubject ,  Observable } from 'rxjs';
import { DataSource } from '@angular/cdk/table';
import { RequeteSummary } from '../../entities/requete';

export enum DisplayedColumn {
    DOSSIER = 'description',
    JURIDICTION = 'juridiction',
    STATUT = 'statut',
    DATE_MAJ = 'dateModification',
    ACTIONS = 'actions'
}

export enum SortDirection {
    ASC = 'asc',
    DESC = 'desc'
}

export enum RequeteStatutFilter {
    ALL = 'All',
    EN_COURS = 'En cours',
    REFUSE = 'Refusé',
    TERMINE = 'Terminé'
}

export class RequetesDataSource extends DataSource<RequeteSummary> {

    sortKey$ = new BehaviorSubject<DisplayedColumn>(DisplayedColumn.DATE_MAJ);

    sortDirection$ = new BehaviorSubject<SortDirection>(SortDirection.DESC);

    statutFilter$ = new BehaviorSubject<RequeteStatutFilter>(RequeteStatutFilter.ALL);

    requetes:  Array<RequeteSummary> = [];

    private displayedRequetes$ = new BehaviorSubject<Array<RequeteSummary>>([]);

    connect(): Observable<RequeteSummary[]> {
        return this.displayedRequetes$;
    }

    disconnect() { }

    init(requetes: Array<RequeteSummary>) {
        this.requetes = requetes;
        this.displayedRequetes$.next(this.sortAndMapRequetes(requetes, this.sortKey$.getValue(), this.sortDirection$.getValue()));

        combineLatest([
            this.sortKey$,
            this.sortDirection$,
            this.statutFilter$]
        ).subscribe(([sortKey, sortDirection, filter]) => {
            const dataToSort = filter === RequeteStatutFilter.ALL ?
            this.requetes : this.requetes.filter(requete => this.hasStatus(requete, filter));
            this.displayedRequetes$.next(this.sortAndMapRequetes(dataToSort, sortKey, sortDirection));
        });
    }

    applyFilter(key: string) {
        this.statutFilter$.next(key as RequeteStatutFilter);
    }

    adjustSort(key: string) {
        if (this.sortKey$.value === key) {
            if (this.sortDirection$.value === SortDirection.ASC) {
                this.sortDirection$.next(SortDirection.DESC);
            } else {
                this.sortDirection$.next(SortDirection.ASC);
            }
            return;
        }
        this.sortKey$.next(key as DisplayedColumn);
        this.sortDirection$.next(SortDirection.DESC);
    }

    hasRequete(): boolean {
        return this.requetes.length > 0;
    }

    private hasStatus(requete: RequeteSummary, status: RequeteStatutFilter): boolean {
        if (status === RequeteStatutFilter.EN_COURS) {
            return requete.statut !== RequeteStatutFilter.TERMINE && requete.statut !== RequeteStatutFilter.REFUSE;
        }
        return requete.statut === RequeteStatutFilter.TERMINE || requete.statut === RequeteStatutFilter.REFUSE;
    }

    private sortAndMapRequetes(requetes: Array<RequeteSummary>, sortKey: DisplayedColumn, sortDirection: SortDirection) {
        return this.sortRequetes(requetes, sortKey, sortDirection)
        .map(requete => [requete, ...requete.dossierCorreles.map(req => { req.isLinked = true; return req; })])
        .reduce((acc, correles) => acc.concat(correles), []);
    }

    private sortRequetes(requetes: Array<RequeteSummary>, sortKey: DisplayedColumn, sortDirection: SortDirection) {
        return requetes.sort((r1, r2) => this.compare(r1[sortKey], r2[sortKey], sortDirection));
    }

    private compare(
        value1: string | Date,
        value2: string | Date,
        sortDirection: SortDirection
    ): number {
        if (value1 > value2) {
            return sortDirection === SortDirection.ASC ? 1 : -1;
        }
        if (value1 < value2) {
            return sortDirection === SortDirection.ASC ? -1 : 1;
        }
        return 0;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/home/mes-dossiers/mes-dossiers.datasource.ts